import React, { useEffect, useRef, useState } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Sort,
  Filter,
  ColumnChooser
} from "@syncfusion/ej2-react-grids";
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-react-grids/styles/material.css';


import { leadsGrid } from "../../data/dummy";
import { Header, Pagination } from "../../components";
import { BASE_URL, get } from "../../Services/Calls";
import { setGridVisibility, getGridVisibility } from '../../Services/gridVisibilityHelper';

const Leads = () => {
  const selectionsettings = { persistSelection: true };
  const toolbarOptions = ['Search', 'ColumnChooser'];
  const editing = { allowDeleting: true, allowEditing: true };

  const [leadsData, setLeadsData] = useState([])


  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const pageSize = 10; // Number of records per page
  const [loading, setLoading] = useState(true);



  const gridRef = useRef(null);


  const pageKey = 'leads-page'; // unique key for each page
  const [isReady, setIsReady] = useState(false);
  const [columnSettings, setColumnSettings] = useState([]);
  useEffect(() => {
    const saved = getGridVisibility(pageKey);
    if (saved) setColumnSettings(saved);

    setIsReady(true);
  }, []);





  const finalColumns = leadsGrid.map((col) => {
    if (!col.field) return col; // Skip if no field (like checkbox/template)

    const match = columnSettings?.find((c) => c.field === col.field);
    return match
      ? { ...col, visible: match.visible }    // apply visibility state
      : { ...col };                           // fallback: visible by default
  });




  const onActionComplete = (args) => {
    if (args.requestType === 'columnstate') {
      const gridCols = gridRef.current?.getColumns() ?? [];
      const state = gridCols
        .filter((c) => !!c.field)
        .map((c) => ({
          field: c.field,
          visible: c.visible,
        }));
      setGridVisibility(pageKey, state);
    }
  };











  // Function to handle page change
  const onPageChange = (page) => {
    setCurrentPage(page);
    getLeads(page)
  };

  // Function to get the current page data
  // const getCurrentPageData = () => {
  //   const startIndex = (currentPage - 1) * pageSize;
  //   const endIndex = startIndex + pageSize;
  //   return leadsData.slice(startIndex, endIndex);
  // };



  useEffect(() => {
    getLeads(currentPage)
  }, [])


  const getLeads = async (pageValue) => {
    setLoading(true);

    try {
      const response = await get(BASE_URL + `/leads?page=${pageValue}&take=10&order=DESC`);
      if (response && response.data && response.data.length > 0) {
        setLeadsData(response.data)
        setTotalPages(Math.ceil(response.meta.itemCount / pageSize))
        setTotalItems(response.meta.itemCount)
      }
    }
    catch (ex) {
      alert(ex)
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-2 ml-10 mr-10 mt-5 p-2 p-5 bg-white rounded-3xl relative">

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-white h-12 w-12 animate-spin"></div>
        </div>
      )}
      <Header category="" title="Leads" />
      {leadsData && leadsData.length > 0 && isReady &&
        <GridComponent
          dataSource={leadsData}
          enableHover={false}
          allowPaging={false}
          // pageSettings={{ pageCount: 5,pageSize: 10 }}
          // selectionSettings={selectionsettings}
          toolbar={toolbarOptions}
          // editSettings={editing}
          allowSorting
          showColumnChooser={true}
          actionComplete={onActionComplete}
          ref={gridRef}

        >
          <ColumnsDirective>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            {finalColumns.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject services={[Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser]} />
        </GridComponent>
      }
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={onPageChange}
        pageHop={2}
      />

    </div>
  );
};

export default Leads;
